import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './ClickOutside.directive';
import { ElasticInputDirective } from './ElasticInput.directive';
import { LogRocketMaskingDirective } from './LogRocketMasking.directive';
import { PiTestingDirective } from './pi-testing.directive';
import { EmailDomainValidatorDirective } from './Validators';
import { EmailValidatorDirective } from './Validators/EmailValidator.directive';
import { EqualValidatorDirective } from './Validators/EqualValidator.directive';
import { PasswordValidatorDirective } from './Validators/PasswordValidator.directive';
import { WhitespaceValidatorDirective } from './Validators/whitespace-validator.directive';

export const DirectivesModuleExports = [
    ClickOutsideDirective,
    ElasticInputDirective,
    EmailValidatorDirective,
    EmailDomainValidatorDirective,
    PasswordValidatorDirective,
    EqualValidatorDirective,
    WhitespaceValidatorDirective,
    PiTestingDirective,
    LogRocketMaskingDirective
];

@NgModule({
    imports: [CommonModule],
    declarations: [...DirectivesModuleExports],
    exports: [...DirectivesModuleExports],
    providers: []
})
export class DirectivesModule {}
